/**
 * Korrigiert die Maus-Trefferkennung von Chart.js unter dem globalen
 * html { zoom: 0.9 } (siehe global.css).
 *
 * Chart.js liest die Zeigerposition aus event.offsetX, das im gerenderten Raum
 * liegt (nach dem Zoom), rechnet sie aber gegen chart.width, das aus der
 * Layoutbreite stammt (vor dem Zoom). Bei zoom 0.9 unterscheiden sich beide um
 * den Faktor 1/0.9. Der gemeldete Punkt wandert deshalb linear nach links: am
 * linken Rand null, am rechten rund zehn Prozent der Diagrammbreite. Auf einer
 * Zeitachse mit zwölf Monaten ist das rechts aussen genau ein Monat daneben,
 * und der Tooltip zeigt den falschen Zeitraum.
 *
 * Gemessen am 3.8.2026 auf dieser Seite: offsetX und clientX - rect.left sind
 * identisch (beide gerendert), clientWidth 900 gegen rect.width 810, also
 * Faktor 1,1111.
 *
 * Der Faktor wird hier am Canvas selbst gemessen und ist ohne Zoom exakt 1,
 * das Plugin ist dann wirkungslos.
 */

/** Layoutbreite geteilt durch gerenderte Breite, oder 1 wenn nicht messbar. */
export function hitScale(canvas) {
  if (!canvas || typeof canvas.getBoundingClientRect !== 'function') {
    return { x: 1, y: 1 };
  }
  const rect = canvas.getBoundingClientRect();
  const x = rect.width > 0 ? canvas.clientWidth / rect.width : 1;
  const y = rect.height > 0 ? canvas.clientHeight / rect.height : 1;
  return {
    x: Number.isFinite(x) && x > 0 ? x : 1,
    y: Number.isFinite(y) && y > 0 ? y : 1,
  };
}

export const zoomHitFix = {
  id: 'zoomHitFix',

  beforeEvent(chart, args) {
    const event = args && args.event;
    if (!event || typeof event.x !== 'number' || typeof event.y !== 'number') {
      return;
    }
    /* Chart.update() spielt das letzte Ereignis erneut durch dieselbe Kette.
       Ohne diese Marke würde derselbe Punkt ein zweites Mal skaliert. */
    if (event.zoomHitFixApplied) {
      return;
    }
    const scale = hitScale(chart.canvas);
    if (Math.abs(scale.x - 1) < 1e-6 && Math.abs(scale.y - 1) < 1e-6) {
      return;
    }
    event.zoomHitFixApplied = true;
    event.x *= scale.x;
    event.y *= scale.y;
    // inChartArea wurde vor diesem Hook aus der unkorrigierten Position
    // bestimmt und muss deshalb neu beurteilt werden.
    if (typeof chart.isPointInArea === 'function') {
      args.inChartArea = chart.isPointInArea(event);
    }
  },
};
